// Font selezionabili per il sito pubblico (Google Fonts). Slug allineati al backend (routes_landing.py).
export const FONTS = {
  inter: { label: "Inter", stack: "'Inter', ui-sans-serif, system-ui, sans-serif", google: "Inter:wght@400;500;600;700;800;900" },
  poppins: { label: "Poppins", stack: "'Poppins', sans-serif", google: "Poppins:wght@400;500;600;700;800;900" },
  montserrat: { label: "Montserrat", stack: "'Montserrat', sans-serif", google: "Montserrat:wght@400;500;600;700;800;900" },
  manrope: { label: "Manrope", stack: "'Manrope', sans-serif", google: "Manrope:wght@400;500;600;700;800" },
  roboto: { label: "Roboto", stack: "'Roboto', sans-serif", google: "Roboto:wght@400;500;700;900" },
  lato: { label: "Lato", stack: "'Lato', sans-serif", google: "Lato:wght@400;700;900" },
  nunito: { label: "Nunito Sans", stack: "'Nunito Sans', sans-serif", google: "Nunito+Sans:wght@400;600;700;800;900" },
  merriweather: { label: "Merriweather (serif)", stack: "'Merriweather', Georgia, serif", google: "Merriweather:wght@400;700;900" },
};

export const DEFAULT_FONT = "inter";
export const FONT_OPTIONS = Object.keys(FONTS);

export const fontStack = (slug) => (FONTS[slug] || FONTS[DEFAULT_FONT]).stack;

// Inietta (una sola volta) il foglio di stile Google Fonts per lo slug indicato.
export const ensureFontLoaded = (slug) => {
  if (typeof document === "undefined") return;
  const f = FONTS[slug] || FONTS[DEFAULT_FONT];
  const id = `gf-${slug}`;
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${f.google}&display=swap`;
  document.head.appendChild(link);
};
